import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import App from './App.vue'
import router from './router'
import store from './store'

import 'vue-snotify/styles/material.css'

const $ = require('jquery')

window.$ = $

Vue.use(Vuelidate)
Vue.use(Snotify, {
  toast: {
    timeout: 6000,
    showProgressBar: true,
    bodyMaxLength: 500,
    position: SnotifyPosition.rightTop,
  },
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
